<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex v-if="!Update_Details">Add Job Listing</v-flex>
                    <v-flex v-else>Update Job Listing</v-flex>
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text v-if="!Update_Details">
                    <v-flex wrap style="padding: 10px;">
                        <v-layout row>
                            <v-select v-if="!AddCategory" item-value='_id' item-text='name' return-object v-model="SelectedJobCategory" :items="JobCategory" label="Select Category">
                                <template slot='selection' slot-scope='{ item }'>
                                    {{ item.Category_Name }}
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    {{ item.Category_Name }}    
                                </template>
                            </v-select>
                            <v-flex v-else style="width: 85%;">
                                <v-text-field label="Job Category" v-model="Category"></v-text-field>
                            </v-flex>
                            <v-btn icon v-if="!AddCategory" @click="OpenUpdate"> <v-icon>add</v-icon> </v-btn>
                            <v-flex v-else style="padding: 13px;">
                                <v-btn icon style="margin:0px;" @click="AddCategoryToDB"> <v-icon>library_add</v-icon> </v-btn>
                                <v-btn icon style="margin:0px;" @click="CloseUpdate"> <v-icon>cancel</v-icon> </v-btn>
                            </v-flex>
                        </v-layout>
                        <v-flex>
                            <v-text-field label="Job Title" v-model="Job_Title"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Company Name" v-model="Company_Name"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Experience" v-model="Experience"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Location" v-model="Location"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Web URL" v-model="Job_Link"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-flex style="font-size: 14px;font-weight: 400;padding-bottom: 10px">Job Description :</v-flex>
                            <vue-editor v-model="Job_Description"></vue-editor>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-card-text v-else>

                    <v-flex wrap style="padding: 10px;">
                        <v-layout row>
                            <v-select item-value='_id' item-text='name' return-object v-model="SelectedJobCategory" :items="JobCategory" label="Select Category">
                                <template slot='selection' slot-scope='{ item }'>
                                    {{ item.Category_Name }}
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    {{ item.Category_Name }}    
                                </template>
                            </v-select>
                        </v-layout>
                        <v-flex>
                            <v-text-field label="Job Title" v-model="Job_Title"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Web URL" v-model="Job_Link"></v-text-field>
                        </v-flex>
                         <v-flex>
                            <v-text-field label="Company Name" v-model="Company_Name"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Experience" v-model="Experience"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Location" v-model="Location"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-flex style="font-size: 14px;font-weight: 400;padding-bottom: 10px">Job Description :</v-flex>
                            <vue-editor v-model="Job_Description"></vue-editor>
                        </v-flex>
                        <v-flex>
                            <v-switch v-model="Enable" :label="`Enable/Disable : ${Enable.toString()}`"></v-switch>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn color="success" v-if="!Update_Details" @click="SubmitJobListing">Add Job Listing</v-btn>
                        <v-btn color="success" v-else @click="UpdateJobListing">Update Job Listing</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    props: ['dialog'],
    data(){
        return {

            Update_Details          : false,
            AddCategory             : false,
            JobCategory             : [],
            SelectedJobCategory     : {},
            Job_Title               : "",
            Job_Description         : "",
            Job_Link                : '',
            Company_Name            : '',
            Experience              : '',
            Location                : '',
            Enable                  : false,
            Category                : "",
            CurrentListing          : {},
            Job_Listing_Id          : ""
        }
    },  
    methods:{
        CloseDialog(){
            
            this.ClearForm()
            this.$emit('close')
        },
        OpenUpdate(){
            this.AddCategory = true
        },
        CloseUpdate(){
            this.AddCategory = false
        },
        AddCategoryToDB(){
            
            let Category = {}
            Category['Category_Name'] = this.Category

            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/joblisting/addjobcategory`,Category)
                        .then(response =>{
                            
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Added Job Category Successfully","Color":"green","Close": false });
                            this.Category   = ''
                            this.JobCategory.push(response["data"]["response"])
                            this.CloseUpdate()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed to Add Job Category","Color":"red","Close": false });
                        })
        },
        SubmitJobListing(){

            let JobListing = {}
            JobListing["Category_Id"]      = this.SelectedJobCategory["_id"]
            JobListing["Job_Title"]        = this.Job_Title
            JobListing['Job_Description']  = this.Job_Description
            JobListing['Link']             = this.Job_Link
            JobListing['Company_Name']     = this.Company_Name
            JobListing['Experience']       = this.Experience
            JobListing['Location']         = this.Location
            JobListing['Enable']           = true
    
            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/joblisting/addJob`,JobListing)
                        .then(response =>{
                            
                            this.$store.commit('SetIndividualJobListing',response["data"]["response"])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added Job Listing","Color":"green","Close": false });
                            this.ClearForm()
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Add Job Listing","Color":"red","Close": false });
                        })
        },
        ClearForm(){

            this.SelectedJobCategory = ""
            this.Job_Title           = ""
            this.Job_Description     = ""
            this.Job_Link            = ''
            this.Company_Name        = ''
            this.Experience          = ''
            this.Location            = ''
            this.Category            = ''
            this.CloseUpdate()
            
        },
        GetJobCategoryList(){

            return new Promise((resolve,reject) =>{

                
                this.$http.get(`${this.$store.getters.GetProductionUrl}/joblisting/getjobcategories`)
                            .then(response =>{
    
                                this.JobCategory = response["data"]["response"]
                                resolve(true)
                            })
                            .catch(err =>{
    
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                                reject(err)
                            })
            })

        },
        GetDetailstoUpdate(JobListing){

            this.Update_Details = true
            this.GetJobCategoryList()
                .then(response =>{

                    this.SelectedJobCategory    = this.JobCategory.find(x => JobListing['Category_Id'])
                    this.Job_Title              = JobListing["Job_Title"]
                    this.Job_Description        = JobListing['Job_Description']
                    this.Job_Link               = JobListing['Link'] 
                    this.Company_Name           = JobListing['Company_Name']   
                    this.Experience             = JobListing['Experience']  
                    this.Location               = JobListing['Location']     
                    this.Enable                 = JobListing['Enable']
                    this.Job_Listing_Id         = JobListing['_id']
                })
                .catch(error =>{

                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                })
        },
        UpdateJobListing(){

            let JobListing = {}
            JobListing['Listing_Id']       = this.Job_Listing_Id
            JobListing['update']           = {}
            JobListing['update']["Category_Id"]      = this.SelectedJobCategory["_id"]
            JobListing['update']["Job_Title"]        = this.Job_Title
            JobListing['update']['Job_Description']  = this.Job_Description
            JobListing['update']['Link']             = this.Job_Link
            JobListing['update']['Company_Name']     = this.Company_Name
            JobListing['update']['Experience']       = this.Experience
            JobListing['update']['Location']         = this.Location
            JobListing['update']['Enable']           = this.Enable
            
            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/joblisting/updatejob`,JobListing)
                        .then(response =>{
                            
                            this.$store.commit('UpdateIndividualJobListing',response["data"]["response"])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated Job Listing","Color":"green","Close": false });
                            this.ClearForm()
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Update Job Listing","Color":"red","Close": false });
                        })
        }
    }
}
</script>
<style scoped>

</style>